// axios
import axios from 'axios';
// routes
import { routes } from "../../../features/routes/route";
// config
import { AuthConfig } from "../../../config/authConfig";
// @ts-ignore
import Cookies from "js-cookie";

export const registerOtp = async (data: any) => {
    const { data: response } = await axios.post(`${routes.api[0].address}MerchantRegister/Verify`, {
        phoneNumber: Cookies.get('mobileNumber'),
        code: data.userInputOtp,
    },
        AuthConfig);
    return response;
};
